import outcomeRestService from '../services/outcome/OutcomeRestService'

const state = {
  outcomes: [],
  filteredOutcomes: [],
  dialogActived: false,
  selectedItem: {},
  defaultItem: {
    id: -1,
    outcomeNumber: '',
    analysisId: null,
    commodityStock: [],
    imgPath: '',
    waybill: '',
    ctg: '',
    loadingDate: '',
    waybillOwner: '',
    commercialSender: '',
    deliveryRepresentative: '',
    receiver: '',
    grossWeight: 0,
    truckWeight: 0,
    obs: '',
    destiny: '',
    carrier: '',
    driverName: '',
    truckPatent: '',
    trailerPatent: '',
    distanceToTravel: 0,
    packagingType: '',
    bagQuantity: 1
  }
}

const getters = {
  getOutcomes: state => state.outcomes,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getDefaultItem: state => state.defaultItem,
  getFilteredOutcomes: state => state.filteredOutcomes
}

const actions = {
  async getOutcomes (context) {
    try {
      let data = await outcomeRestService.getOutcomes()
      context.commit('setOutcomes', data)
    } catch (error) {
      console.log('Error fetching outcomes')
    }
  },
  async saveOutcome (context, outcomeInfo) {
    let snackBarContent = {actived: true, message: 'Salida Agregada Exitosamente.', color: 'success'}
    try {
      await outcomeRestService.saveOutcome(outcomeInfo)
    } catch (error) {
      snackBarContent = {actived: true, message: 'Error Agregando Salida.', color: 'error'}
      throw error
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  },
  async filterItems (context, filters) {
    context.commit('filterOutcome', filters)
  },
  refreshFilteredOutcomes (context) {
    context.commit('refreshFilteredOutcomes')
  }
}

const mutations = {
  setOutcomes (state, outcomes) {
    state.outcomes = outcomes
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  filterOutcome (state, filters) {
    state.filteredOutcomes = state.outcomes.filter(outcome => {
      const date = outcome.loadingDate || ''
      const commodities = Array.isArray(outcome.commodities) ? outcome.commodities : Object.values(outcome.commodities || {})
      return (!filters.dateFrom || date >= filters.dateFrom) &&
        (!filters.dateTo || date <= filters.dateTo) &&
        (!filters.receiverId || Number(outcome.receiver?.id) === Number(filters.receiverId)) &&
        (!filters.grainTypeId || commodities.some(item => Number(item.grainType?.id) === Number(filters.grainTypeId)))
    })
  },
  refreshFilteredOutcomes (state) {
    state.filteredOutcomes = state.outcomes
  },
  setSelectedItemAsDefault (state) {
    state.selectedItem = state.defaultItem
    state.selectedItem.commodityStock = []
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
